<script lang="ts" setup>
import WidgetLayout from '../WidgetLayout.vue'
import type { ButtonStyleOptions, TranslatableString } from '~/types/widgets/widgetTypes'

const props = defineProps<{
  slug: TranslatableString
  backgroundMobile: TranslatableString
  backgroundDesktop: TranslatableString
  backgroundColor?: string
  buttonStyle: ButtonStyleOptions[] | ButtonStyleOptions | string
  buttonText: TranslatableString
  openLinksInNewTab?: boolean
}>()
</script>

<template>
  <WidgetLayout :background-color="props.backgroundColor" class-name="!pb-4">
    <LazyStoreBanner v-bind="props" banner-style="Full" />
  </WidgetLayout>
</template>
